import { render, staticRenderFns } from "./creat-video.vue?vue&type=template&id=53b4ebc6&scoped=true"
import script from "./creat-video.vue?vue&type=script&lang=js"
export * from "./creat-video.vue?vue&type=script&lang=js"
import style0 from "./creat-video.vue?vue&type=style&index=0&id=53b4ebc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b4ebc6",
  null
  
)

export default component.exports